var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "pb-16" };
var _hoisted_2 = { class: "container" };
var _hoisted_3 = { class: "flex items-center justify-center flex-wrap space-x-12" };
var _hoisted_4 = ["href"];
var _hoisted_5 = {
    key: 0,
    class: "flex items-center justify-center group/label",
    href: "https://skillspace.ru",
    target: "_blank"
};
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "mx-5 w-0.5 h-5 bg-gray-300" }, null, -1);
var _hoisted_7 = { class: "text-gray-500 group-hover/label:text-dark" };
import passData from '@common/utils/PassData';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LandingFooter',
    setup: function (__props) {
        var t = useI18n().t;
        var showTreaty = !window.__passdata.dontUseDogovor;
        var whiteLabelHideLogo = passData.schoolSettings.whiteLabelHideLogo;
        var studentLawLinks = ref([
            {
                label: t('footer.privacyPolicy'),
                url: "/docs/policy",
            },
        ]);
        if (showTreaty) {
            studentLawLinks.value = __spreadArray(__spreadArray([], __read(studentLawLinks.value), false), [
                {
                    label: t('footer.offerAgreement'),
                    url: "/docs/oferta",
                },
            ], false);
        }
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(studentLawLinks.value, function (link) {
                            return (_openBlock(), _createElementBlock("li", {
                                key: link.url
                            }, [
                                _createElementVNode("a", {
                                    href: link.url,
                                    class: "py-2 inline-flex text-gray-500 hover:underline",
                                    rel: "noopener noreferrer",
                                    target: "_blank"
                                }, _toDisplayString(link.label), 9, _hoisted_4)
                            ]));
                        }), 128))
                    ]),
                    (!_unref(whiteLabelHideLogo))
                        ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                            _createVNode(_component_e_icon, {
                                class: "w-[104px] text-gray-400 group-hover/label:text-green",
                                icon: "brands/skillspace"
                            }),
                            _hoisted_6,
                            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('footer.poweredBySkillspace')), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
